function debounceFaq(func, wait = 700, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
var theme = {
    createTemplateVariableEncoder: function () {
        return {
            utilityElement: document.createElement('div'),
            values: {},
            add: function add(key, value, type) {
                switch (type) {
                    case 'attribute':
                        this.utilityElement.innerHTML = '';
                        this.utilityElement.setAttribute('util', value);
                        this.values[key] = this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1];
                        break;
                    case 'html':
                        this.utilityElement.innerText = value;
                        this.values[key] = this.utilityElement.innerHTML;
                        break;
                    case 'raw':
                        this.values[key] = value;
                        break;
                    default:
                        throw "Type '".concat(type, "' not handled");
                }
            }
        };
    }
};

(function FaqHeader() {

    const classNames = {
        questionContainerInactive: 'faq-search-item-inactive',
        sectionWithIndexStatus: 'section-faq-header--with-index'
    };
    let searchInput, linkedCollapsibleTabs = [], linkedQuestionContainers = [], linkedContent = [];
    createTemplateVariableEncoder = function () {
        return {
            utilityElement: document.createElement('div'),
            values: {},
            /**
             * Add a new value to sanitise.
             * @param {String} key - key used to retrieve this value
             * @param {String} value - the value to encode and store
             * @param {String} type - possible values: [attribute, html, raw] - the type of encoding to use
             */
            add: function add(key, value, type) {
                switch (type) {
                    case 'attribute':
                        this.utilityElement.innerHTML = '';
                        this.utilityElement.setAttribute('util', value);
                        this.values[key] = this.utilityElement.outerHTML.match(/util="([^"]*)"/)[1];
                        break;
                    case 'html':
                        this.utilityElement.innerText = value;
                        this.values[key] = this.utilityElement.innerHTML;
                        break;
                    case 'raw':
                        this.values[key] = value;
                        break;
                    default:
                        throw "Type '".concat(type, "' not handled");
                }

            }
        };
    };
    function buildIndex(container) {
        const faqHeaderSection = container.closest('.section-faq-header'),
            indexContainer = container.querySelector('.faq-index__item-container');

        if (indexContainer) {
            indexContainer.querySelectorAll('.faq-index-item').forEach((element) => {
                element.parentNode.removeChild(element);
            });
        }

        var currentElement = faqHeaderSection;
        while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('section-collapsible-tabs')) {
            currentElement = currentElement.nextElementSibling;

            // build list of searchable content
            linkedCollapsibleTabs.push(currentElement);
            currentElement.querySelectorAll('.collapsible-tabs__tab').forEach((element) => linkedQuestionContainers.push(element));
            currentElement.querySelectorAll('.collapsible-tabs__content').forEach((element) => linkedContent.push(element));

            // build index UI
            if (indexContainer) {
                var currentElementHeading = currentElement.querySelector('.collapsible-tabs__heading');
                if (currentElementHeading) {
                    var tve = theme.createTemplateVariableEncoder();
                    tve.add('title_id', currentElementHeading.id, 'attribute');
                    tve.add('title', currentElementHeading.innerHTML, 'raw');

                    var html = "\n              <div class=\"faq-index-item\">\n                <a class=\"faq-index-item__link\" href=\"#".concat(

                        tve.values.title_id, "\">").concat(tve.values.title, "</a>\n              </div>");

                    var htmlFragment = document.createRange().createContextualFragment(html);
                    indexContainer.appendChild(htmlFragment);
                }
            }
        }

        if (indexContainer) {
            resizeIndex(container);
        }
    }
    let registeredEventListeners = [];
    function _registerEventListener(element, eventType, callback) {
        element.addEventListener(eventType, callback);
        registeredEventListeners.push({
            element,
            eventType,
            callback
        });
    }
    function resizeIndex(container) {
        console.log(container)
        const stickyContainer = container.querySelector('.faq-index__sticky-container'),
            faqHeaderSection = container.closest('.section-faq-header');

        let currentElement = faqHeaderSection;
        while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('section-collapsible-tabs')) {
            currentElement = currentElement.nextElementSibling;
        }

        const stickyContainerRect = stickyContainer.getBoundingClientRect(),
            currentElementRect = currentElement.getBoundingClientRect();

        stickyContainer.style.height = currentElementRect.bottom - stickyContainerRect.top + 'px';
    }

    function performSearch() {
        // defer to avoid input lag
        setTimeout(() => {
            var splitValue = searchInput.value.split(' ');

            // sanitise terms
            var terms = [];
            splitValue.forEach((t) => {
                if (t.length > 0) {
                    terms.push(t.toLowerCase());
                }
            });

            // search
            linkedQuestionContainers.forEach((element) => {
                if (terms.length) {
                    var termFound = false;
                    var matchContent = element.textContent.toLowerCase();
                    terms.forEach((term) => {
                        if (matchContent.indexOf(term) >= 0) {
                            termFound = true;
                        }
                    });
                    if (termFound) {
                        element.classList.remove(classNames.questionContainerInactive);
                    } else {
                        element.classList.add(classNames.questionContainerInactive);
                    }
                } else {
                    element.classList.remove(classNames.questionContainerInactive);
                }
            });

            // hide non-question content if doing a search
            linkedContent.forEach((element) => {
                if (terms.length) {
                    element.classList.add(classNames.questionContainerInactive);
                } else {
                    element.classList.remove(classNames.questionContainerInactive);
                }
            });
        }, 10);
    }


    function handleIndexClick(evt) {
        if (evt.target.classList.contains('faq-index-item__link')) {
            evt.preventDefault();
            var id = evt.target.href.split('#')[1];
            var scrollTarget = document.getElementById(id);
            var scrollTargetY = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 100;

            // sticky header offset
            var stickyHeight = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
            if (stickyHeight) {
                scrollTargetY -= parseInt(stickyHeight);
            }

            window.scrollTo({
                top: scrollTargetY,
                behavior: 'smooth'
            });
        }
    }

    function debouncedBuildIndex(container) {
        return debounceFaq(() => buildIndex(container), 50);
    }

    function onSectionLoad(container) {
        searchInput = container.querySelector('.faq-search__input');
        if (searchInput) {
            searchInput.addEventListener('change', performSearch);
            searchInput.addEventListener('keyup', performSearch);
            searchInput.addEventListener('paste', performSearch);
        }

        const debouncedIndex = debouncedBuildIndex(container);
        _registerEventListener(document, 'theme:faq-header-update', debouncedIndex);
        debouncedIndex();


        if (container.querySelector('.faq-index')) {
            _registerEventListener(container, 'click', handleIndexClick);
            container.closest('.section-faq-header').classList.add(classNames.sectionWithIndexStatus);
            resizeIndex(container);
            _registerEventListener(window, 'resize', debounce(resizeIndex.bind(null, container), 250));
        }
    }

    function onSectionReorder(container) {
        debouncedBuildIndex();
    }
    document.addEventListener('DOMContentLoaded', function () {
        onSectionLoad(document.querySelector('.faq-header'));
    });

})();